import React from "react";
import Checkbox from "../ui/checkbox";

// showPriceLock=false hides the price-lock paragraph (Ship Direct orders expire
// on their own, so only the binding-agreement checkbox applies there).
// error=true marks the checkbox red and explains why the order was not created.
const CreateOrderAgreement = ({ checked, onChange, showPriceLock = true, error = false }) => (
  <div
    style={{
      border: "1px solid rgba(232, 184, 75, 0.22)",
      background: "rgba(232, 184, 75, 0.08)",
      borderRadius: 10,
      padding: "12px 14px",
      marginTop: 14,
    }}
  >
    {showPriceLock && (
      <div style={{ fontSize: 12.5, lineHeight: 1.55, color: "#f2f4f5", marginBottom: 10 }}>
        <strong style={{ color: "#fff" }}>Price lock — two deadlines:</strong>
        <ul style={{ margin: "6px 0", paddingLeft: 18, listStyleType: "disc" }}>
          <li>Create your shipment within 48 hours of approval</li>
          <li>Hand off to the carrier within 48 hours of label issuance</li>
        </ul>
        Miss the first and your order may be repriced at current market rates. Miss the second and the shipment is cancelled.
      </div>
    )}
    <label
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: 10,
        cursor: "pointer",
      }}
    >
      {/* outline (not border) so the Checkbox hover styles don't reset the ring */}
      <Checkbox
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        size={20}
        style={{
          marginTop: 1,
          outline: checked ? "none" : `1.5px solid ${error ? "#f27059" : "#00ADB5"}`,
          outlineOffset: -1.5,
        }}
      />
      <span style={{ fontSize: 12.5, lineHeight: 1.5, color: "#f2f4f5" }}>
        I understand this order is a binding commitment to sell these units at the quoted price. If I don't ship the approved units, RSC may
        charge a cancellation fee of 25% of the order value.
      </span>
    </label>
    {error && (
      <div style={{ fontSize: 12.5, fontWeight: 700, color: "#f27059", marginTop: 8, paddingLeft: 30 }}>
        Please tick the box above to agree to the terms before creating your order.
      </div>
    )}
  </div>
);

export default CreateOrderAgreement;
